// frontend/src/utils/passwordValidator.js

/**
 * Validates password according to security requirements:
 * - At least 8 characters long
 * - Contains at least one uppercase letter
 * - Contains at least one lowercase letter
 * - Contains at least one number
 * - Contains at least one special character
 */
export function validatePassword(password) {
  const errors = [];
  
  if (!password || password.length < 8) {
    errors.push('Password must be at least 8 characters long');
  }
  
  if (!/[A-Z]/.test(password)) {
    errors.push('Password must contain at least one uppercase letter');
  }
  
  if (!/[a-z]/.test(password)) {
    errors.push('Password must contain at least one lowercase letter');
  }
  
  if (!/[0-9]/.test(password)) {
    errors.push('Password must contain at least one number');
  }
  
  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)) {
    errors.push('Password must contain at least one special character');
  }
  
  return {
    isValid: errors.length === 0,
    errors: errors,
    message: errors.join('. ')
  };
}

/**
 * Get password strength indicator
 * @param {string} password 
 * @returns {object} { strength: 'weak'|'medium'|'strong', percentage: number }
 */
export function getPasswordStrength(password) {
  if (!password) return { strength: 'weak', percentage: 0 };
  
  let score = 0;
  
  // Length score
  if (password.length >= 8) score += 20;
  if (password.length >= 12) score += 10;
  if (password.length >= 16) score += 10;
  
  // Character variety score
  if (/[a-z]/.test(password)) score += 15;
  if (/[A-Z]/.test(password)) score += 15;
  if (/[0-9]/.test(password)) score += 15;
  if (/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)) score += 15;
  
  // Bonus for mixing
  if (/[a-z]/.test(password) && /[A-Z]/.test(password) && 
      /[0-9]/.test(password) && /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)) {
    score += 20;
  }
  
  let strength = 'weak';
  if (score >= 60) strength = 'medium';
  if (score >= 80) strength = 'strong';
  
  return { strength, percentage: Math.min(score, 100) };
}